export default __webpack_public_path__ + "img/mc_vrt_opt_pos_73_3x.fab47be3.png";